<script type="text/javascript">
export default {};
</script>

<template>
  <div class="market-chart-loader">
    <div class="market-chart-loader__sine-wave"></div>
    <div class="market-chart-loader__content">
      <div class="market-chart-loader__text-1"></div>
      <div class="market-chart-loader__text-2"></div>
      <div class="market-chart-loader__text-3"></div>
      <div class="market-chart-loader__text-4"></div>
      <div class="market-chart-loader__text-5"></div>
      <div class="market-chart-loader__text-6"></div>
      <div class="market-chart-loader__text-7"></div>
      <div class="market-chart-loader__text-8"></div>
      <div class="market-chart-loader__text-9"></div>
      <div class="market-chart-loader__text-10"></div>
    </div>
  </div>
</template>

<style lang="scss">
.market-chart-loader {
  @import '~styles/settings';

  background: $white;
  height: 250px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;

  body[data-theme='dark'] & {
    background: var(--surface-panel);
  }

  &__sine-wave {
    position: absolute;
    top: 20%; // Give some space for "highs"
    left: 0;
    width: 100%;
    height: 60%; // The chart body height
    background: linear-gradient(
      to bottom,
      rgba(198, 235, 242, 0.8) 0%,
      rgba(198, 235, 242, 0.1) 100%
    );

    body[data-theme='dark'] & {
      background: linear-gradient(
        to bottom,
        rgba(117, 213, 237, 0.35) 0%,
        rgba(117, 213, 237, 0.05) 100%
      );
    }
    // This creates a jagged "chart line" using coordinates
    clip-path: polygon(
      0% 70%,
      10% 65%,
      20% 80%,
      30% 40%,
      45% 55%,
      55% 30%,
      70% 50%,
      80% 20%,
      90% 45%,
      100% 30%,
      100% 100%,
      0% 100%
    );

    opacity: 0.6;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: -150%;
      width: 150%;
      height: 100%;
      background: linear-gradient(
        to right,
        transparent 0%,
        rgba(255, 255, 255, 0.4) 50%,
        transparent 100%
      );
      animation: shimmer 2s infinite;

      body[data-theme='dark'] & {
        background: linear-gradient(
          to right,
          transparent 0%,
          rgba(241, 245, 248, 0.15) 50%,
          transparent 100%
        );
      }
    }
  }

  &__content {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-end;
    gap: 12px;
    position: relative;
    z-index: 1;
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(166%);
  }
}
</style>
